<template>
  <div class="pdf-screenshot-container">
    <!-- 工具栏 -->
    <div class="pdf-toolbar">
      <select v-model="renderScale" @change="handleRenderScaleChange" class="render-scale-select">
        <option :value="1">标准清晰度</option>
        <option :value="2">高清(2x)</option>
        <option :value="3">超清(3x)</option>
        <option :value="4">超高清(4x)</option>
      </select>
      <button @click="zoomOut" :disabled="zoom <= 0.5">缩小(-)</button>
      <button @click="zoomIn" :disabled="zoom >= 5">放大(+)</button>
      <button @click="resetZoom">重置缩放</button>
      <button @click="rotateCounterClockwise" title="逆时针旋转90度">↺ 逆时针旋转</button>
      <button @click="rotateClockwise" title="顺时针旋转90度">↻ 顺时针旋转</button>
      <button
          @click="toggleDarkMode"
          :class="{ 'active': isDarkMode }"
          title="切换深色/浅色模式"
      >
        {{ isDarkMode ? '浅色模式' : '深色模式' }}
      </button>
      <button
          @click="toggleDragMode"
          :class="{ 'active': isDragMode }"
          title="启用拖曳模式后可拖动查看 PDF"
      >
        {{ isDragMode ? '退出拖曳' : '拖曳' }}
      </button>
      <button @click="startSelect" :disabled="isSelecting">添加选框</button>
      <button @click="clearAllSelected" :disabled="selectedAreas.length === 0">清空所有选择</button>
      <span class="zoom-info">当前缩放: {{ Math.round(zoom * 100) }}%</span>
      <span class="rotation-info" v-if="rotation !== 0">
        旋转角度: {{ rotation }}°
      </span>
      <span class="selection-info" v-if="selectedAreas.length > 0">
        已选择 {{ selectedAreas.length }} 个区域
      </span>
    </div>
    
    
    
    
    <!-- PDF容器（可滚动） -->
    <div class="pdf-container" ref="pdfContainer">
      <!-- PDF内容容器（实际渲染PDF的容器，所有坐标基于此） -->
      <div class="pdf-content" ref="pdfContent" v-longpress="handleLongPress">
        <!-- PDF页面渲染容器（单独分离，避免框选标记被清空） -->
        <div class="pdf-pages-container" ref="pdfPagesContainer"></div>
        
        <!-- 框选遮罩（仅框选过程中显示） -->
        <div
            v-if="isSelecting"
            class="select-mask"
        ></div>
        
        <!-- 框选区域（框选过程中） -->
        <div
            v-if="isSelecting && selectRect"
            class="select-rect"
            :style="{
            left: selectRect.x + 'px',
            top: selectRect.y + 'px',
            width: selectRect.width + 'px',
            height: selectRect.height + 'px'
          }"
        ></div>
        
        <!-- 多个框选区域标记（框选完成后显示） -->
        <div
            v-for="(area, areaIndex) in selectedAreas"
            :key="areaIndex"
            class="selected-mark"
            :style="{
            left: area.x + 'px',
            top: area.y + 'px',
            width: area.width + 'px',
            height: area.height + 'px'
          }"
        >
          <!-- 截图按钮 - 改为打开弹窗 -->
          <div class="screenshot-buttons">
            <el-button
                type="primary"
                @click="openScreenshotDialog2(area.x)"
                class="screenshot-btn"
            >
              添加意见
            </el-button>
            <!-- 单个删除按钮 -->
            <el-button
                type="danger"
                @click="deleteSingleArea(areaIndex)"
                class="delete-area-btn"
            >
              删除
            </el-button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 加载提示 -->
    <div class="loading" v-if="isLoading">
      加载中...
    </div>
    
    <!-- 错误提示 -->
    <div class="error" v-if="errorMsg">
      {{ errorMsg }}
    </div>
    
    <!-- 截图预览弹窗（Element UI） -->
    <el-dialog
        title="截图预览（整个PDF页面 + 所有框选标记）"
        :visible.sync="isScreenshotDialogOpen"
        :center="true"
        :append-to-body="true"
        width="60%"
    >
      <el-form label-width="120px">
        <el-form-item label="截图内容:">
          <div class="screenshot-preview-container">
            <el-image
                :src="positionImg"
                fit="contain"
                class="preview-image"
                :preview-src-list="[positionImg]"
            >
              <div slot="error" class="image-error">
                图片加载失败
              </div>
            </el-image>
          </div>
        </el-form-item>
        <template>
          <div class="opinion-container" style="padding: 20px; max-width: 800px; margin: 0 auto;">
            <!-- 标题 -->
            <div class="title" style="font-size: 16px; font-weight: 500; margin-bottom: 15px;">
              生成问题:
            </div>
            
            <!-- 多组意见列表 -->
            <div class="opinion-list">
              <div
                  class="opinion-item"
                  v-for="(item, index) in opinionList"
                  :key="item.id || index"
                  style="border: 1px solid #e6e6e6; padding: 15px; border-radius: 4px; margin-bottom: 15px;"
              >
                <!-- 搜索栏 -->
                <div style="display: flex; align-items:baseline;">
                  <span style="width: 100px;">搜索：</span>
                  <el-input
                      placeholder="请输入搜索内容"
                      prefix-icon="el-icon-search"
                      style="width: 100%; margin-bottom: 20px;"
                      v-model="item.searchValue"
                      @focus="changeSearchValue(index)"
                  ></el-input>
                </div>
                
                <!-- 生成问题 -->
                <!-- ... existing code ... -->
                <div style="display: flex; align-items:baseline; margin-bottom: 10px; flex-wrap: wrap; line-height: 2;">
                  <span style="width: 100px; flex-shrink: 0;">生成问题：</span>
                  
                  <div v-for="(item, inde) in parsedContent[index] || []" :key="inde" style="display: inline-flex; align-items: baseline; margin: 4px 0;">
                    <!-- 纯文本段 -->
                    <div v-if="typeof item === 'string'" style="white-space: nowrap;">
                      {{ item }}
                    </div>
                    <!-- 选项组段 -->
                    <div v-else class="item-group" style="display: inline-flex; align-items: baseline;">
                      <el-select
                          v-model="item.value"
                          :multiple="item.type === 'multiple'"
                          :placeholder="item.type === 'multiple' ? '请选择多项' : '请选择一项'"
                          class="select-segment"
                          style="width: 200px; margin: 0 4px;"
                          @change="generateFinalString(index)"
                      >
                        <el-option
                            v-for="(option, optIndex) in item.options"
                            :key="optIndex"
                            :label="option"
                            :value="option"
                        />
                      </el-select>
                      <!-- 可选：添加红色提示文字（验证失败时显示） -->
                      <span v-if="validateError && !item.value" class="error-tip">请选择此项</span>
                    </div>
                  </div>
                </div>
                <!-- ... existing code ... -->
                
                
                <!-- 违反条文输入框 -->
                <div style="display: flex; align-items:baseline;">
                  <span style="width: 100px;">违反条文：</span>
                  <el-input
                      disabled
                      v-model="item.drStandardItemDescribe"
                      placeholder="违反条文"
                      style="width: 100%; margin-bottom: 15px;"
                  ></el-input>
                </div>
                <!-- 意见具体化输入框 -->
                <div style="display: flex; align-items:baseline;">
                  <span style="width: 100px;">意见具体化：</span>
                  <el-input
                      v-model="item.specificOpinions"
                      placeholder="意见具体化"
                      style="width: 100%; margin-bottom: 15px;"
                  ></el-input>
                </div>
                <!-- 意见预览文本域 -->
                <div style="display: flex; align-items:baseline;">
                  <span style="width: 100px;">意见预览：</span>
                  <el-input
                      disabled
                      v-model="item.opinionPreview"
                      type="textarea"
                      placeholder="意见预览"
                      rows="6"
                      style="width: 100%; margin-bottom: 15px;"
                  ></el-input>
                </div>
                <!-- 删除本条按钮 -->
                <el-button
                    type="text"
                    icon="el-icon-circle-close"
                    style="color: #ff4d4f; border: 1px dashed #ff4d4f; width: 100%; padding: 8px 0;"
                    @click="deleteOpinion(index)"
                >
                  删除本条
                </el-button>
              </div>
            </div>
            
            <!-- 添加意见按钮 -->
            <el-button
                type="text"
                icon="el-icon-plus"
                style="width: 100%; border: 1px dashed #ccc; padding: 8px 0;"
                @click="addOpinion"
            >
              添加意见
            </el-button>
          </div>
        </template>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="isScreenshotDialogOpen = false">关闭</el-button>
        <el-button type="primary"  @click="confirmQuestion">
          添加审查意见
        </el-button>
      </div>
    </el-dialog>
    
    <el-dialog
        title="问题库查询"
        :visible.sync="searchValueDialog"
        :center="true"
        :append-to-body="true"
        width="60%"
    >
      <el-form label-width="120px">
        <el-form-item label="问题搜索:">
          <el-input
              placeholder="请输入搜索内容"
              prefix-icon="el-icon-search"
              style="width: 100%; "
              v-model="problemFileter.keyword"
              @input="getQuestionList"
          ></el-input>
        </el-form-item>
        <el-form-item label="事项:">
          <el-select v-model="problemFileter.itemType" clearable @change="getQuestionList" style="width: 100%" multiple placeholder="请选择事项">
            <el-option
                v-for="item in itemTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.name"
            >
              {{ item.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指定规范:">
          <el-select v-model="problemFileter.standardId" @change="getQuestionList" style="width: 100%"  clearable filterable placeholder="请选择">
            <el-option
                v-for="item in standardList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <template>
            <div
                class="opinion-container"
                style="
                padding: 0 20px 20px;
                margin: 0 auto;
                border: 1px solid #ccc;
                border-radius: 20px;
                min-height: 200px;
                max-height: 500px;
                overflow-y: auto;
                overflow-x: hidden;
              "
            >
              <div v-for="(item,index) in opinionProblemList" style="margin: 10px;" :key="index">
                <div @click="clickStanard(item)">
                  <el-popover
                      placement="right"
                      title="规范条纹"
                      @click="clickStanard(item)"
                      width="300"
                      trigger="hover"
                      :content='item.drStandardItemSerialNumber+" "+item.drStandardItemSerialContent'>
                    <el-button slot="reference">
                      <div style="white-space: normal;text-align: left;font-size: 15px; line-height: 1.3; ">
                        ({{item.ddIdQuestionPropertieValue}})
                        《{{item.drStandardName}}》
                        {{item.drStandardItemSerialNumber}}
                        问题描述：{{ item.questionDescription }}
                        ({{item.itemType === 1 ? '重要' : item.itemType === 9 ? '其他' : '提示'}})
                      </div>
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddDialog">取消</el-button>
        <el-button type="primary" @click="confirmAddDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import {
  addConfirmedOpinionByTechnology,
  addExpertOpinion,
  addOpinion,
  getDrStandardList,
  getQuestionPageList,
  uploadImagesUrl,
  uploadPic
} from "@/api/api";

// 配置pdfjs工作器
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
  name: 'PdfScreenshotViewer',
  props: {
    // PDF文件URL
    pdfUrl: {
      type: String,
      required: true
    },
    // 初始缩放比例
    initialZoom: {
      type: Number,
      default: 1
    },
    needDataItem:{
      type: Object,
      required: true
    },
    // 最小缩放比例
    minZoom: {
      type: Number,
      default: 0.5
    },
    // 最大缩放比例
    maxZoom: {
      type: Number,
      default: 5.0
    },
    // 缩放步进（滚轮每一档的增量）
    scaleStep: {
      type: Number,
      default: 0.1
    },
  },
  data() {
    return {
      ndex: 0, // 当前索引
      validateError: false, // 标记验证状态
      isDragMode: false, // 新增：拖曳模式开关
      isDragging: false, // 新增：正在拖曳中
      dragStart: { x: 0, y: 0 }, // 新增：拖曳起始位置
      scrollStart: { x: 0, y: 0 }, // 新增：容器滚动起始位置
      lastZoom: null, // 记录上一次的缩放比例
      renderScale: 1, // 渲染倍率（1=标准, 2=高清, 3=超高清）
      rotation: 0, // 当前旋转角度（0, 90, 180, 270）
      isDarkMode: false, // 深色模式开关
      problemFileter:{
        keyword:undefined,
        itemType:[1,9,99],
        standardId:undefined
      },
      itemTypeList:[
        { value:1, name:"重要" },
        { value:9, name:"其他" },
        { value:99, name:"提示" },
      ],
      opinionProblemList: [],
      searchValueDialog:false,
      opinionList: [
        {
          searchValue:undefined,
          confirmProblem:undefined,
          drStandardItemDescribe: undefined, // 违反条文
          specificOpinions: undefined, // 意见具体化
          opinionPreview: undefined ,// 意见预览
          finalString:undefined,
          drQuestionId:undefined,
          drStandardItemId:undefined,
          opinionType:124,
        }
      ],
      isLoading: false,
      errorMsg: '',
      zoom: 1,
      isSelecting: false,
      selectRect: null, // 框选过程中的临时矩形（基于pdf-content坐标）
      selectedAreas: [], // 改为数组：存储多个确认后的选择区域
      pdfDoc: null, // PDF文档实例
      pageCanvases: [], // 页面canvas元素数组
      pdfContentSize: { width: 0, height: 0 }, // PDF内容总尺寸（基于pdf-content）
      // 弹窗相关状态
      isScreenshotDialogOpen: false, // 弹窗显示状态
      screenshotUrl: '', // 截图图片URL
      dialogWidth: 1200 ,// 弹窗宽度
      standardList:undefined,
      itemStandard:undefined,
      questionIndex:undefined,
      parsedContent: [],
      drawing:undefined, // 改为存储所有选框的坐标集合
      positionImg:undefined,
      pendingAdjust: null, // 用于以鼠标为中心缩放的临时变量
      currentSelectedArea: undefined, // 当前选框值
      pageWidth: 0, // 当前PDF页面宽度（基于pdf-content）
      pageHeight: 0, // 当前PDF页面高度（基于pdf-content）
    };
  },
  watch: {
    pdfUrl: {
      immediate: true,
      handler() {
        this.loadPdf();
      }
    },
    zoom(newVal, oldVal) {
      if (this.pdfDoc) {
        this.renderPages(newVal);
      }
    },
    isDarkMode(newVal) {
      this.$nextTick(() => {
        this.applyDarkMode();
      });
    }
  },
  methods: {
    // 处理渲染倍率变化
    handleRenderScaleChange() {
      if (this.pdfDoc) {
        this.renderPages(this.zoom);
      }
    },
    // 处理滚轮事件（Ctrl+ 滚轮实现缩放）
    handleWheel(e) {
      
      const container = this.$refs.pdfContainer
      if (!container) return

      const delta = e.deltaY > 0 ? -this.scaleStep : this.scaleStep
      const oldZoom = this.zoom
      let newZoom = oldZoom + delta

      // 限制范围
      newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, newZoom))
      if (newZoom === oldZoom) return

      console.log('newZoom',newZoom)

      // --- 记录鼠标相对于容器的坐标 ---
      const rect = container.getBoundingClientRect()
      const mouseX = e.clientX - rect.left
      const mouseY = e.clientY - rect.top

      // --- 转换为"内容坐标"（考虑当前滚动偏移） ---
      const contentX = (mouseX + container.scrollLeft) / oldZoom
      const contentY = (mouseY + container.scrollTop) / oldZoom

      // 更新缩放
      this.zoom = newZoom

      // 保存待调整的滚动信息（渲染完成后应用）
      this.pendingAdjust = {
        mouseX,
        mouseY,
        contentX,
        contentY,
        newZoom
      }

      // 重新渲染所有页面
      this.applyScrollAdjust()
    },

    /* ---------- 应用滚动偏移（保持鼠标指向内容不变） ---------- */
    applyScrollAdjust() {
      if (!this.pendingAdjust) return

      const container = this.$refs.pdfContainer
      if (!container) return

      const { mouseX, mouseY, contentX, contentY, newZoom } = this.pendingAdjust

      // 计算新的滚动偏移
      const newScrollLeft = contentX * newZoom - mouseX
      const newScrollTop = contentY * newZoom - mouseY

      console.log('滚动偏移',newScrollLeft,newScrollTop)

      container.scrollLeft = newScrollLeft
        container.scrollTop = newScrollTop

      this.pendingAdjust = null
    },
    
    // 切换拖曳模式
    toggleDragMode() {
      this.isDragMode = !this.isDragMode;
      if (this.isDragMode) {
        // 进入拖曳模式：禁用框选，改变光标
        this.isSelecting = false;
        this.selectRect = null;
      }
    },
    handleLongPress(e){
		if (this.isDragMode || this.isSelecting) return;
		this.isDragMode = true;
		this.handleDragStart(e)
	},
    // 开始拖曳
    handleDragStart(e) {
      if (!this.isDragMode || this.isSelecting) return;
      
      this.isDragging = true;
      this.dragStart = {
        x: e.clientX,
        y: e.clientY
      };
      
      const container = this.$refs.pdfContainer;
      this.scrollStart = {
        x: container.scrollLeft,
        y: container.scrollTop
      };
      
      container.style.cursor = 'grabbing';
      e.preventDefault();
    },
    
    // 拖曳中
    handleDrag(e) {
      if (!this.isDragging || !this.isDragMode) return;
      
      const deltaX = e.clientX - this.dragStart.x;
      const deltaY = e.clientY - this.dragStart.y;
      
      const container = this.$refs.pdfContainer;
      container.scrollLeft = this.scrollStart.x - deltaX;
      container.scrollTop = this.scrollStart.y - deltaY;
      
      e.preventDefault();
    },
    
    // 结束拖曳
    handleDragEnd() {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      const container = this.$refs.pdfContainer;
      if (container && this.isDragMode) {
        container.style.cursor = 'grab';
      }
    },
    
    /**
     * 生成最终字符串：多选用顿号分隔（无{}），单选直接展示（无()）
     */
    generateFinalString(index) {
      let result = '';
      this.parsedContent[index]?.forEach(item => {
        if (typeof item === 'string') {
          // 纯文本段直接拼接
          result += item;
        } else {
          // 选项组段：处理选中值（无括号）
          let selectedValue = '';
          if (item.type === 'multiple') {
            // 多选：数组转顿号（、）分隔的字符串
            selectedValue = item.value.join('、');
          } else {
            // 单选：直接取字符串值
            selectedValue = item.value;
          }
          // 拼接选中值（无任何括号包裹）
          result += selectedValue;
        }
      });
      this.opinionList[index].finalString = result;
      this.opinionList[index].confirmProblem = result;
      this.opinionList[index].opinionPreview = `${result}违反《${this.itemStandard?.drStandardName || ''}》${this.itemStandard?.drStandardBn || ''}第${this.itemStandard?.drStandardItemSerialNumber || ''}
问题属性：${this.itemStandard?.ddIdQuestionPropertieValue || ''}
问题分类：${this.itemStandard?.ddIdQuestionTypeValue || ''}`;
      this.opinionList[index].specificOpinions = result;
    },
    
    parseString() {
      const str = this.opinionList[this.questionIndex].searchValue;
      if (!str) return;
      // 关键修复：给中文括号匹配部分加分组括号，保持分组逻辑一致
      const reg = /({[^}]+})|(（[^）]+）)/g;
      let lastIndex = 0;
      const result = [];
      
      str.replace(reg, (match, group1, group2, index) => {
        // 1. 先拼接匹配位置前的纯文本
        if (index > lastIndex) {
          result.push(str.slice(lastIndex, index));
        }
        
        let type = '';
        let content = '';
        
        if (group1) {
          // 匹配到 {} 包裹的内容（多选）
          type = 'multiple';
          content = group1.slice(1, -1); // 去掉 {}
        } else if (group2) {
          // 匹配到 （） 包裹的内容（单选）
          type = 'single';
          content = group2.slice(1, -1); // 去掉中文括号（）
        }
        
        // const options = content.split('；').map(opt => opt.trim());
        const options = content.split('；');
        
        // 加入选项组对象
        result.push({
          type,
          options,
          value: type === 'multiple' ? [] : ''
        });
        
        // 更新最后匹配位置
        lastIndex = index + match.length;
        return match;
      });
      
      // 2. 拼接最后一段纯文本
      if (lastIndex < str.length) {
        result.push(str.slice(lastIndex));
      }
      
      this.parsedContent[this.questionIndex] = result;
    },
    
    confirmAddDialog() {
      if (!this.itemStandard) return;
      this.opinionList[this.questionIndex].searchValue = this.itemStandard.questionDescription;
      this.opinionList[this.questionIndex].confirmProblem = this.itemStandard.questionDescription;
      this.opinionList[this.questionIndex].drStandardItemDescribe = `《${this.itemStandard.drStandardName}》${this.itemStandard.drStandardBn}第${this.itemStandard.drStandardItemSerialNumber}`;
      this.opinionList[this.questionIndex].specificOpinions = this.itemStandard.specificOpinions?this.itemStandard.specificOpinions:this.itemStandard.questionDescription;
      this.opinionList[this.questionIndex].opinionPreview = `${this.itemStandard.questionParsing}违反《${this.itemStandard.drStandardName}》${this.itemStandard.drStandardBn}第${this.itemStandard.drStandardItemSerialNumber}
问题属性：${this.itemStandard.ddIdQuestionPropertieValue}
问题分类：${this.itemStandard.ddIdQuestionTypeValue}`;
      this.opinionList[this.questionIndex].drQuestionId = this.itemStandard.id;
      this.opinionList[this.questionIndex].drStandardItemId = this.itemStandard.drStandardItemId;
      this.parseString();
      this.searchValueDialog = false;
    },
    
    closeAddDialog() {
      this.problemFileter = {
        keyword:undefined,
        itemType:undefined,
        standardId:undefined
      };
      this.itemStandard = undefined;
      this.searchValueDialog = false;
    },
    
    clickStanard(item){
      this.itemStandard = item;
    },
    
    //根据问题编号或者内容获取问题库分页列表
    async getQuestionList(){
      const params = {
        pageIndex: 1,
        pageSize: 30,
        keyword: this.problemFileter.keyword,
        itemType: this.problemFileter.itemType?.join(',') || '',
        standardId: this.problemFileter.standardId,
        sourceType:'winform'
      };
      const res = await getQuestionPageList(params);
      if (res.data.success) {
        this.opinionProblemList = res.data.response.data;
      }
    },
    
    // 查询意见
    async changeSearchValue(index){
      this.questionIndex = index;
      let params = {
        keyword: undefined,
        ddIdNodeBizType:100,
        pageIndex: 1,
        pageSize: 10000000,
      };
      const res = await getDrStandardList(params);
      if (res.data.success) {
        this.standardList = res.data.response.data;
      }
      this.searchValueDialog = true;
    },
    
    // 新增意见
    addOpinion() {
      const newId = this.opinionList.length > 0
          ? Math.max(...this.opinionList.map(item => item.id || 0)) + 1
          : 1;
      this.opinionList.push({
        id: newId,
        searchValue:undefined,
        confirmProblem:undefined,
        drStandardItemDescribe: undefined,
        specificOpinions: undefined,
        opinionPreview: undefined,
        finalString:undefined,
        drQuestionId:undefined,
        drStandardItemId:undefined,
        opinionType:124,
      });
    },
    
    // 删除指定意见
    deleteOpinion(index) {
      // 至少保留1条意见
      if (this.opinionList.length <= 1) {
        this.$message.warning("至少保留一条意见");
        return;
      }
      this.opinionList.splice(index, 1);
      // 同步删除对应的解析内容
      this.parsedContent.splice(index, 1);
    },
    
    // 加载PDF
    async loadPdf() {
      if (!this.pdfUrl) return;
      
      this.isLoading = true;
      this.errorMsg = '';
      this.pageCanvases = [];
      this.selectedAreas = []; // 清空所有选框
      this.isScreenshotDialogOpen = false;
      this.screenshotUrl = '';
      
      try {
        // 加载PDF文档
        this.pdfDoc = await pdfjsLib.getDocument({
          url: this.pdfUrl,
          cMapPacked: true, // 支持中文
          cMapUrl: 'https://unpkg.com/pdfjs-dist@3.4.120/cmaps/' // 中文映射文件
        }).promise;
        
        // 渲染页面
        await this.renderPages(this.zoom);
      } catch (error) {
        console.error('PDF加载失败:', error);
        this.errorMsg = 'PDF加载失败，请检查URL是否有效';
      } finally {
        this.isLoading = false;
      }
    },
    
    // 渲染所有页面
    async renderPages(zoom) {
      const pdfPagesContainer = this.$refs.pdfPagesContainer;
      const pdfContent = this.$refs.pdfContent;
      if (!pdfPagesContainer || !pdfContent || !this.pdfDoc) return;
      
      // 只清空PDF页面容器，保留框选标记
      pdfPagesContainer.innerHTML = '';
      this.pageCanvases = [];
      
      const pageCount = this.pdfDoc.numPages;
      let totalHeight = 0;
      let maxWidth = 0;
      
      for (let pageNum = 1; pageNum <= pageCount; pageNum++) {
        // 获取页面
        const page = await this.pdfDoc.getPage(pageNum);
        
        // 1. 基础缩放 + 高清倍率，提升物理分辨率
        const baseViewport = page.getViewport({ scale: zoom, rotation: this.rotation });
        // 计算高清渲染的视口（物理尺寸 = 显示尺寸 * renderScale）
        const renderViewport = page.getViewport({
          scale: zoom * this.renderScale,
          rotation: this.rotation,
          // 开启抗锯齿（部分浏览器需要）
          antialias: true
        });

        if(pageNum === 1){
          this.pageWidth = baseViewport.width;
          this.pageHeight = baseViewport.height;
        }
        
        // 创建canvas元素
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        
        // 2. 设置canvas物理尺寸（高清）
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        // 3. 设置canvas显示尺寸（和原尺寸一致，避免页面变形）
        canvas.style.width = `${baseViewport.width}px`;
        canvas.style.height = `${baseViewport.height}px`;
        // 开启canvas自身的抗锯齿
        canvas.style.imageRendering = 'pixelated'; // 可选，根据需求调整
        canvas.className = 'pdf-page-canvas';
        
        // 添加到页面容器
        pdfPagesContainer.appendChild(canvas);
        this.pageCanvases.push(canvas);
        
        // 4. 优化渲染参数（提升精度）
        const renderContext = {
          canvasContext: context,
          viewport: renderViewport,
          // 启用高质量渲染模式
          intent: 'display',
          // 禁用不必要的优化，保证精度
          disableCombineTextItems: false
        };
        await page.render(renderContext).promise;
        
        // 添加页面间距
        const marginBottom = 10;
        canvas.style.marginBottom = `${marginBottom}px`;
        
        // 计算PDF内容总尺寸（基于显示尺寸，而非物理尺寸）
        totalHeight += baseViewport.height + marginBottom;
        maxWidth = Math.max(maxWidth, baseViewport.width);
      }
      
      // 保存PDF内容总尺寸（基于显示尺寸）
      this.pdfContentSize = {
        width: maxWidth,
        height: totalHeight - 10 // 减去最后一个页面的marginBottom
      };
      
      // 确保pdf-content容器尺寸正确（基于显示尺寸）
      pdfContent.style.width = `${maxWidth}px`;
      
      // 重新计算已选区域的坐标（考虑缩放比例变化）
      if (this.selectedAreas.length > 0 && this.lastZoom && this.lastZoom !== zoom) {
        const scaleRatio = zoom / this.lastZoom;
        this.selectedAreas = this.selectedAreas.map(area => ({
          x: area.x * scaleRatio,
          y: area.y * scaleRatio,
          width: area.width * scaleRatio,
          height: area.height * scaleRatio
        }));
      }
      this.lastZoom = zoom;
    },

    
    
    // 转换鼠标坐标到pdf-content容器内
    convertMouseToContentCoord(e) {
      const pdfContent = this.$refs.pdfContent;
      if (!pdfContent) return { x: 0, y: 0 ,pageWidth:0,pageHeight:0};
      
      const rect = pdfContent.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const pageWidth = this.pageWidth || rect.width;
      const pageHeight = this.pageHeight || rect.height;
     
      return { x, y, pageWidth, pageHeight };
    },
    
    // 放大
    zoomIn() {
      // this.zoom += 0.1;

      const container = this.$refs.pdfContainer
      const oldZoom = this.zoom
      const newZoom = Math.min(this.maxZoom, oldZoom + 0.1)
      if (newZoom === oldZoom) return

      // 以容器中心为缩放中心
      if (container) {
        const rect = container.getBoundingClientRect()
        const centerX = rect.width / 2
        const centerY = rect.height / 2

        this.pendingAdjust = {
          mouseX: centerX,
          mouseY: centerY,
          contentX: (centerX + container.scrollLeft) / oldZoom,
          contentY: (centerY + container.scrollTop) / oldZoom,
          newZoom
        }
      }

      this.zoom = newZoom
      this.applyScrollAdjust()
    },
    
    // 缩小
    zoomOut() {
      // this.zoom -= 0.1;
      const container = this.$refs.pdfContainer
      const oldZoom = this.zoom
      const newZoom = Math.max(this.minZoom, oldZoom - 0.1)
      if (newZoom === oldZoom) return

      if (container) {
        const rect = container.getBoundingClientRect()
        const centerX = rect.width / 2
        const centerY = rect.height / 2

        this.pendingAdjust = {
          mouseX: centerX,
          mouseY: centerY,
          contentX: (centerX + container.scrollLeft) / oldZoom,
          contentY: (centerY + container.scrollTop) / oldZoom,
          newZoom
        }
      }

      this.zoom = newZoom
      this.applyScrollAdjust()
    },
    
    resetZoom() {
      this.zoom = this.initialZoom;
    },
    
    // 顺时针旋转90度
    rotateClockwise() {
      this.rotation = (this.rotation + 90) % 360;
      this.renderPages(this.zoom);
    },
    
    // 逆时针旋转90度
    rotateCounterClockwise() {
      this.rotation = (this.rotation - 90 + 360) % 360;
      this.renderPages(this.zoom);
    },
    
    // 切换深色模式
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      this.applyDarkMode();
    },
    
    // 应用深色模式效果
    applyDarkMode() {
      const pdfContent = this.$refs.pdfContent;
      if (!pdfContent) return;
      
      if (this.isDarkMode) {
        // 深色模式：反转颜色
        pdfContent.style.filter = 'invert(1) hue-rotate(180deg)';
        // 对canvas元素单独处理，避免边框也被反转
        const canvases = pdfContent.querySelectorAll('canvas');
        canvases.forEach(canvas => {
          canvas.style.filter = 'invert(1) hue-rotate(180deg)';
        });
      } else {
        // 浅色模式：恢复正常
        pdfContent.style.filter = '';
        const canvases = pdfContent.querySelectorAll('canvas');
        canvases.forEach(canvas => {
          canvas.style.filter = '';
        });
      }
      this.renderPages(this.zoom)
    },
    
    // 开始框选
    startSelect() {
      this.isSelecting = true;
      this.selectRect = null;
      document.body.style.cursor = 'crosshair';
      document.body.style.userSelect = 'none';
    },
    
    // 清空所有选框
    clearAllSelected() {
      this.selectedAreas = [];
      this.isSelecting = false;
      this.selectRect = null;
      this.isScreenshotDialogOpen = false;
      this.screenshotUrl = '';
      document.body.style.cursor = 'default';
      document.body.style.userSelect = 'auto';
    },
    
    // 删除单个选框
    deleteSingleArea(areaIndex) {
      this.selectedAreas.splice(areaIndex, 1);
      // 如果删除后无选框，清空截图相关状态
      if (this.selectedAreas.length === 0) {
        this.isScreenshotDialogOpen = false;
        this.screenshotUrl = '';
      }
    },
    
    // 鼠标按下 - 开始框选
    handleMouseDown(e) {
      if (!this.isSelecting) return;
      const { x, y, pageWidth, pageHeight } = this.convertMouseToContentCoord(e);
      this.selectRect = { x, y, width: 0, height: 0, pageWidth, pageHeight, zoom: this.zoom };
    },
    
    // 鼠标移动 - 更新框选区域
    handleMouseMove(e) {
      if (!this.isSelecting || !this.selectRect) return;
      
      const { x: currentX, y: currentY , pageWidth:currentPageWidth, pageHeight:currentPageHeight} = this.convertMouseToContentCoord(e);
      this.selectRect = {
        x: Math.min(currentX, this.selectRect.x),
        y: Math.min(currentY, this.selectRect.y),
        width: Math.abs(currentX - this.selectRect.x),
        height: Math.abs(currentY - this.selectRect.y), 
        pageWidth:currentPageWidth, 
        pageHeight:currentPageHeight,
        zoom: this.zoom
      };
    },
    
    // 鼠标松开 - 完成单个框选
    handleMouseUp() {
      if (!this.isSelecting || !this.selectRect) return;
      
      // 最小框选尺寸限制
      if (this.selectRect.width < 20 || this.selectRect.height < 20) {
        this.selectRect = null;
        document.body.style.cursor = 'default';
        document.body.style.userSelect = 'auto';
        return;
      }
      console.log(this.selectRect,"handleMouseUp")
      // 将当前选框推入数组
      this.selectedAreas.push({ ...this.selectRect });
      this.isSelecting = false;
      this.selectRect = null; // 清空临时选框
      document.body.style.cursor = 'default';
      document.body.style.userSelect = 'auto';
    },
    
    openScreenshotDialog2(x = 0){
      // 从 selectedAreas 中筛选出 x 相等的 areaIndex
      const areaIndex = this.selectedAreas.findIndex(area => area.x === x);
      if (areaIndex === -1) {
        this.$message.warning('未找到匹配的选框');
        return;
      }
      this.openScreenshotDialog(areaIndex);
    },
    // 生成整页截图+所有框选标记并打开弹窗
    async openScreenshotDialog(currentAreaIndex = 0) {
      this.parsedContent = [];
      this.opinionList= [
        {
          searchValue:undefined,
          confirmProblem:undefined,
          drStandardItemDescribe: undefined,
          specificOpinions: undefined,
          opinionPreview: undefined,
          finalString:undefined,
          drQuestionId:undefined,
          drStandardItemId:undefined,
          opinionType:124,
        }
      ];
      
      if (this.selectedAreas.length === 0 || this.pageCanvases.length === 0) return;
      
      this.isLoading = true;
      
      try {
        const { width: totalWidth, height: totalHeight } = this.pdfContentSize;
        const centerX = totalWidth / 2;
        const centerY = totalHeight / 2;
        
        // 获取当前点击的选框
        const currentArea = this.selectedAreas[currentAreaIndex];
        if (!currentArea) return;
        
        // 收集当前选框的四维坐标（适配原有drawing逻辑）
        this.drawing = [];
        const { x: ox, y: oy, width: ow, height: oh } = currentArea;
        this.drawing.push([
          ox - centerX,       // 左上角x相对中心的偏移
          oy - centerY,       // 左上角y相对中心的偏移
          (ox + ow) - centerX,// 右下角x相对中心的偏移
          (oy + oh) - centerY // 右下角y相对中心的偏移
        ]);

        this.currentSelectedArea = currentArea; // 保存当前选框
        
        // 1. 计算当前选框的边界范围（只处理当前选框）
        let minX = currentArea.x;
        let minY = currentArea.y;
        let maxX = currentArea.x + currentArea.width;
        let maxY = currentArea.y + currentArea.height;
        
        // 2. 扩展200px边距
        const padding = 200;
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(totalWidth, maxX + padding);
        maxY = Math.min(totalHeight, maxY + padding);
        
        const cropWidth = maxX - minX;
        const cropHeight = maxY - minY;
        
        // 3. 创建裁剪区域的截图Canvas
        const screenshotCanvas = document.createElement('canvas');
        const ctx = screenshotCanvas.getContext('2d');
        screenshotCanvas.width = cropWidth;
        screenshotCanvas.height = cropHeight;
        
        // 4. 填充白色背景
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, cropWidth, cropHeight);
        
        // 5. 绘制PDF页面到截图Canvas（只绘制裁剪区域）
        for (let i = 0; i < this.pageCanvases.length; i++) {
          const canvas = this.pageCanvases[i];
          const canvasX = canvas.offsetLeft;
          const canvasY = canvas.offsetTop;
          // 使用CSS显示尺寸，而非物理像素尺寸
          const displayWidth = parseFloat(canvas.style.width);
          const displayHeight = parseFloat(canvas.style.height);
          
          // 计算当前页面与裁剪区域的交集
          const sourceX = Math.max(0, minX - canvasX);
          const sourceY = Math.max(0, minY - canvasY);
          const sourceRight = Math.min(displayWidth, maxX - canvasX);
          const sourceBottom = Math.min(displayHeight, maxY - canvasY);
          
          // 如果没有交集，跳过此页面
          if (sourceX >= sourceRight || sourceY >= sourceBottom) continue;
          
          // 计算在源canvas上的实际像素坐标（考虑高清渲染倍率）
          const scaleX = canvas.width / displayWidth;
          const scaleY = canvas.height / displayHeight;
          const actualSourceX = sourceX * scaleX;
          const actualSourceY = sourceY * scaleY;
          const actualSourceWidth = (sourceRight - sourceX) * scaleX;
          const actualSourceHeight = (sourceBottom - sourceY) * scaleY;
          
          // 绘制到目标canvas（相对于裁剪区域的位置）
          const targetX = canvasX + sourceX - minX;
          const targetY = canvasY + sourceY - minY;
          const targetWidth = sourceRight - sourceX;
          const targetHeight = sourceBottom - sourceY;
          
          ctx.drawImage(
              canvas,
              actualSourceX, actualSourceY,
              actualSourceWidth, actualSourceHeight,
              targetX, targetY,
              targetWidth, targetHeight
          );
        }
        
        // 6. 绘制当前选框标记（高亮+边框），坐标需要转换为相对于裁剪区域
        const relativeX = currentArea.x - minX;
        const relativeY = currentArea.y - minY;
        
        // 高亮背景
        ctx.fillStyle = 'rgba(64, 158, 255, 0.15)';
        ctx.fillRect(relativeX, relativeY, currentArea.width, currentArea.height);
        // 内层实线边框
        ctx.strokeStyle = '#409eff';
        ctx.lineWidth = 3;
        ctx.strokeRect(relativeX, relativeY, currentArea.width, currentArea.height);
        // 外层虚线边框
        ctx.strokeStyle = '#2691f6';
        ctx.lineWidth = 1;
        ctx.setLineDash([5, 3]);
        ctx.strokeRect(relativeX - 2, relativeY - 2, currentArea.width + 4, currentArea.height + 4);
        ctx.setLineDash([]);
        
        // 7. 生成截图URL并打开弹窗
        this.screenshotUrl = screenshotCanvas.toDataURL('image/png', 1);
        this.isScreenshotDialogOpen = true;
        
        // 8. 将截图URL转换为Blob并上传
        const blob = await this.dataURLToBlob(this.screenshotUrl);
        const formData = new FormData();
        formData.append('file', blob, 'clip.png'); // 文件名固定为clip.png
        const uploadResult = await uploadPic(formData);
        if (uploadResult.data.success) {
          this.positionImg = uploadResult.data.response.weburl;
        } else {
          this.$message.warning('截图上传失败，请重试');
        }
      } catch (error) {
        console.error('生成截图失败:', error);
        this.$message.error('生成截图失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    
    
    
    // 辅助函数：将dataURL转换为Blob对象
    dataURLToBlob(dataURL) {
      return new Promise((resolve) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        resolve(new Blob([u8arr], { type: mime }));
      });
    },
    
    // 核心验证函数：检查所有选项组是否已选择
    validateSelectOptions() {
      this.validateError = false;
      // 遍历所有意见项的解析内容
      for (let i = 0; i < this.parsedContent.length; i++) {
        const currentList = this.parsedContent[i] || [];
        for (const item of currentList) {
          if (typeof item !== 'string') {
            const isEmpty = item.type === 'multiple'
                ? item.value.length === 0
                : item.value === undefined;
            if (isEmpty) {
              this.validateError = true;
              this.$message.error('存在未选择的选项，请完成选择后提交');
              return false;
            }
          }
        }
      }
      return true;
    },
    
    // 确认意见
    confirmQuestion() {
      // 1. 先执行验证
      const isValid = this.validateSelectOptions();
      if (!isValid) return;
      
      this.$confirm('是否提交图审意见？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          drProjectFileId: this.needDataItem.id.toString(),
          drProjectId: this.needDataItem.projectId,
          drawing: this.drawing[0], // 所有选框坐标
          // drawingJson: JSON.stringify(this.drawing),
          drawingJson: JSON.stringify(this.currentSelectedArea),
          positionImg: this.positionImg,
          projectOpinionList: this.opinionList
        };
      
        const user = window.localStorage.getItem('user');
        const userData = user ? JSON.parse(user) : {};
        const isTechExpert = userData.roleNames && userData.roleNames.includes('总工室技术专家');
        
        const apiMethod = isTechExpert ? addConfirmedOpinionByTechnology : addExpertOpinion;
        const res = await apiMethod(params);
        
        if (res.data.success) {
          this.$message.success('提交成功');
          this.isScreenshotDialogOpen = false;
          // 提交成功后可选择清空选框
          // this.selectedAreas = [];
        } else {
          this.$message.error(res.data.message || '提交失败');
        }


        
      });
    }
  },
  mounted() {
    const pdfContent = this.$refs.pdfContent;
    const pdfContainer = this.$refs.pdfContainer;
    
    if (pdfContent) {
      pdfContent.addEventListener('mousedown', this.handleMouseDown);
      pdfContent.addEventListener('mousemove', this.handleMouseMove);
      pdfContent.addEventListener('mouseup', this.handleMouseUp);
      pdfContent.addEventListener('mouseleave', this.handleMouseUp);
    }
    
    if (pdfContainer) {
      pdfContainer.addEventListener('mousedown', this.handleDragStart);
      pdfContainer.addEventListener('wheel', this.handleWheel, { passive: false });
      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.handleDragEnd);
    }
  },
  beforeUnmount() {
    const pdfContent = this.$refs.pdfContent;
    const pdfContainer = this.$refs.pdfContainer;
    
    if (pdfContent) {
      pdfContent.removeEventListener('mousedown', this.handleMouseDown);
      pdfContent.removeEventListener('mousemove', this.handleMouseMove);
      pdfContent.removeEventListener('mouseup', this.handleMouseUp);
      pdfContent.removeEventListener('mouseleave', this.handleMouseUp);
    }
    
    if (pdfContainer) {
      pdfContainer.removeEventListener('mousedown', this.handleDragStart);
      pdfContainer.removeEventListener('wheel', this.handleWheel);
    }
    document.removeEventListener('mousemove', this.handleDrag);
    document.removeEventListener('mouseup', this.handleDragEnd);
  }

};
</script>

<style scoped>
.pdf-toolbar button.active:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.render-scale-select {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #606266;
}

.render-scale-select:hover {
  border-color: #409eff;
}

.render-scale-select:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 8px;
}

.pdf-toolbar button.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.pdf-toolbar button.active:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}



.rotation-info {
  color: #67c23a;
  font-size: 14px;
  margin-left: 15px;
  padding: 4px 8px;
  background: rgba(103, 194, 58, 0.1);
  border-radius: 4px;
}

.selection-info {
  color: #409eff;
  font-size: 14px;
  margin-left: 15px;
  padding: 4px 8px;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 4px;
}

.pdf-toolbar button {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.pdf-toolbar button.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.pdf-toolbar button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.pdf-toolbar button:hover:not(:disabled) {
  background: #f0f0f0;
  border-color: #ccc;
}

.pdf-toolbar button.active:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}



.pdf-screenshot-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pdf-toolbar {
  padding: 10px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pdf-toolbar button {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.pdf-toolbar button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.pdf-toolbar button:hover:not(:disabled) {
  background: #f0f0f0;
  border-color: #ccc;
}

.zoom-info {
  margin-left: auto;
  color: #666;
}

.selection-info {
  color: #409eff;
  font-size: 14px;
  margin-left: 15px;
  padding: 4px 8px;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 4px;
}

/* PDF容器（可滚动） */
.pdf-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f9f9f9;
}

/* PDF内容容器 */
.pdf-content {
  margin: 0 auto;
  position: relative;
  padding: 0;
}

/* PDF页面容器 */
.pdf-pages-container {
  width: 100%;
}

.pdf-page-canvas {
  display: block;
  border: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  background: #fff;
}

/* 框选遮罩 */
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 10;
  pointer-events: none;
}

/* 框选区域（过程中） */
.select-rect {
  position: absolute;
  border: 2px solid #409eff;
  background: rgba(64, 158, 255, 0.1);
  z-index: 20;
  pointer-events: none;
}

/* 框选标记（完成后） */
.selected-mark {
  position: absolute;
  z-index: 30;
  pointer-events: none;
}

/* 框选高亮 */
.selected-mark::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(64, 158, 255, 0.2);
  border: 2px solid #409eff;
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.3);
  z-index: 31;
}

/* 截图按钮容器 */
.screenshot-buttons {
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  pointer-events: auto;
}

.screenshot-btn, .delete-area-btn {
  padding: 10px 20px !important;
  border-radius: 6px !important;
  font-size: 14px !important;
}

.loading, .error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  padding: 20px;
  border-radius: 8px;
  z-index: 100;
}

.loading {
  color: #666;
  background: rgba(255,255,255,0.8);
}

.error {
  color: #f56c6c;
  background: rgba(255,255,255,0.9);
}

/* 弹窗预览容器 */
.screenshot-preview-container {
  padding: 10px;
  text-align: center;
  max-height: 300px;
  width: 80%;
  overflow: auto;
}

/* 整页截图预览样式 */
.preview-image {
  max-height: 80vh;
  max-width: 100%;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.image-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  border: 1px solid #eee;
  color: #999;
}

.dialog-footer {
  text-align: right;
}

/* 错误提示文字 */
.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 8px;
}
</style>